import React from 'react';
import RecipeInstructionElement from './RecipeInstructionElement/RecipeInstructionElement'


function RecipeInstructions({ inputInstructions, changeHandler, showInstructions, depth = 0 }) {
    const indexedInstructions = inputInstructions?.map((element, index) => {
        return {
            ...element,
            index: index
        }
    })

    const onChange = (instruction, index) => {
        var newInstructionsArray = [...inputInstructions]
        if (instruction) {
            newInstructionsArray[index] = instruction;
        } else {
            newInstructionsArray.splice(index, 1)
            newInstructionsArray = newInstructionsArray.map((element, index) => {
                return {
                    ...element,
                    index: index
                }
            })
        }
        changeHandler(newInstructionsArray);
    };

    function addAfterHandler(e) {
        e.preventDefault();
        const location = e.target.id.slice(12);
        var newInstructionsArray = [...inputInstructions];

        newInstructionsArray.splice(location, 0, {
            Instruction_Text: "",
            Instruction_Time: 0
        })

        var newElementArray = newInstructionsArray.map((element, index) => {
            return ({
                ...element,
                index: index
            })
        });
        changeHandler(newElementArray);
    }

    return (
        <div className={"instruction-array-container column " + (indexedInstructions?.length > 0 ? "filled" : "")} style={{ display: showInstructions ? 'flex' : 'none' }}>
            {changeHandler ? <button id={"Instruction_0"} className="button add-new-instruction" onClick={addAfterHandler} >+</button> : null}
            <ul>
                {
                    indexedInstructions?.map((element) => {
                        return (
                            <li key={element.index}>
                                <RecipeInstructionElement id={"Instruction_Element_" + element.index} index={element.index} inputInstruction={element} changeHandler={changeHandler ? onChange : null} />
                                {changeHandler ? <button id={"Instruction_" + (element.index + 1)} onClick={addAfterHandler}>+</button> : null}
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}


export default RecipeInstructions;